import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-left"><path d="M16.0258 4.29233C17.8513 3.37989 20 4.70668 20 6.74799V17.2519C20 19.2932 17.8513 20.62 16.0258 19.7076L5.51814 14.4556C3.49395 13.4439 3.49396 10.556 5.51814 9.54431L16.0258 4.29233Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowTriangleLeft;
